<template>
<div>

  <!-- <el-row> -->
   <!-- <el-col :span="17"> -->
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Opportunity</el-breadcrumb-item>
    <el-breadcrumb-item>Timeline</el-breadcrumb-item>
  </el-breadcrumb>
<!-- </el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row> -->
<el-dialog title="IMPORT FILE" :visible.sync="dialogVisibleImport"  width="35%">
  <el-form  :inline="true" class="demo-form-inline">
    <!-- <el-upload
      class="upload-demo"
      v-model="projectOpenform.docReference"
      action="http://51.68.206.7:8081/customer/fileUpload"
      multiple
      show-file-list
      accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .csv"
      :on-preview="handlePreviewDoc"
      :on-success="handleSuccessDoc"
      :on-remove="handleRemoveDoc"
      :file-list="docList"
      list-type="text">
      <el-button size="small" v-if="operation==='edit' || operation==='add'" type="primary">Click to upload</el-button>
      <div slot="tip" class="el-upload__tip" v-if="operation==='edit' || operation==='add'">docx/xlsx/xls/ppt/pptx/csv/pdf files with a size less than 500kb</div>
    </el-upload> https://www.myirequest.com
    -->
    <el-upload
      class="upload-demo"
      ref="upload"
      action="https://www.myirequest.com:8081/timeline/importFile"
      accept=".xls, .xlsx"
      :multiple="false"
      :file-list="fileList">
      <el-button slot="trigger" size="small" type="primary">Import</el-button>
      <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">Import</el-button> -->
      <div slot="tip" class="el-upload__tip">xlsx/xls files</div>
    </el-upload>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="dialogVisibleImport = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseFile">Ok</el-button>
  </div>
</el-dialog>
<el-dialog title="SUPPLIER FIRST ESTIMATE" :visible.sync="dialogVisible"  width="35%">
  <el-form  :inline="true" class="demo-form-inline">
    <el-form-item label="">
      <el-select v-model="selectedItem" placeholder="Please Choose">
      <el-option
            v-for="item in this.firstoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="Date">
      <el-date-picker
            v-model="tlsupplyDate"
            type="date"   value-format="yyyy-MM-dd" :disabled="chooseDate()"
            placeholder="Choose Date">
          </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button v-if="this.operation==='edit' || this.operation==='add'" @click="dialogVisible = false">Cancel</el-button>
    <el-button v-if="this.operation==='edit' || this.operation==='add'" type="primary" @click="chooseFirstDate">Ok</el-button>
  </div>
</el-dialog>
<el-dialog title="Project Id Choose" :visible.sync="projectidDialogVisible"  width="35%">
  <el-form :inline="true" :model="ruleForm" class="demo-form-inline" label-width="175px" ref="editFormRef" :rules="editFormRules">

    <el-form-item label="Project Id" prop="selectedProjectId">
      <el-select v-model="ruleForm.selectedProjectId" placeholder="Please Choose" style="width: 200px" filterable remote
       :remote-method="remoteMethod" :loading="loading">
      <el-option
            v-for="item in this.projectIdList"
            :key="item.project_id"
            :label="item.project_id"
            :value="item.project_id">
            <span style="float: left">{{ item.project_id }}</span>
            <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.descr }}</span>
          </el-option>
      </el-select>
      </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="projectidDialogVisible = false">Cancel</el-button>
    <el-button type="primary" @click="timelineOpen">Ok</el-button>
  </div>
</el-dialog>
<div id="printTest">
  <el-dialog title="SUPPLIER TIMELINE" class="dialogTitle"
    width="70%" :visible.sync="dialogFormVisible">
    <el-form :label-position="labelPosition" :model="timelineOpenform" width="100%" label-width="250px">
      <div class="div-table">
      <table class="table-body" cellspacing=0 cellpadding=0>
          <tbody>
              <tr>
                  <td width="100%" colspan="8" class="section-header">PROJECT DESCRIPTION</td>
              </tr>
              <tr>
                <td width="10%" class="header">Project Id:</td>
                <td colspan="2">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.projectId}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.projectId" type="text"
                    class="item-input1" readonly="readonly"/>
                </td>
                <td colspan="2">Project Descr:</td>
                <td colspan="3">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.projectDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.projectDescr" type="text"
                     class="item-input1" readonly="readonly"/>
                </td>
                </tr>
                <tr>
                  <td width="20%" class="header" colspan="1">Customer Name:</td>
                              <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.customerName}}</div>
                              <el-select v-model="timelineOpenform.timeline.customerName" collapse-tags
                        size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        placeholder="please choose">
                      <el-option
                      v-for="item in this.customerNames"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                  </td>
                </tr>
              <tr>
                  <td width="20%" class="header" colspan="1">Component ID:</td>
                  <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.componentId}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.componentId" type="text"
                    class="item-input2"/></td>
              </tr>
              <tr>
                  <td width="20%" class="header">Component Description:</td>
                  <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.componentDescr}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.componentDescr" type="text"
                    class="item-input2"/></td>
                    <!-- <input type="text" v-model="timelineOpenform.timeline.componentDescr" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                <td width="20%" class="header">Brand:</td>
                <td colspan="7">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.brand}}</div>
                  <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.brand" type="text"
                    class="item-input2" readonly="readonly"/>
                </td>
              </tr>
              <tr>
              <td width="20%" class="header" colspan="1">Item:</td>
                          <td colspan="7"><div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.item}}</div>
                          <el-select v-model="timelineOpenform.timeline.item"  filterable collapse-tags clearable
                                style="display: flex;"  v-if="this.operation==='edit' || this.operation==='add'"
                                placeholder="please choose"  size="mini">
                                <el-option-group>
                                      <span style="float: left; margin-left: 20px; font-size: 10px;width: 30px;">Code</span>
                                      <span style="margin-left: 100px; font-size: 10px;display:inline-block;width: 150px;">Description</span>
                              <el-option
                              v-for="item in this.categoryList"
                              :key="item.code"
                              :label="item.code"
                              :value="item.code">
                              <span style="float: left; width: 30px;">{{ item.code }}</span>
                              <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
                            </el-option>
                            </el-option-group>
                          </el-select>
                          <!-- <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.item" type="text"
                             width="100%"  class="item-input" /> --></td>
                             </tr>
              <tr>
                  <td width="20%" class="header">Revision #:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.revision}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.revision" type="text"
                      class="item-input2"/></td>
                    <!--  <input type="number" v-model="timelineOpenform.timeline.revision" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="20%" class="header">Date Submitted:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{dateFormat1(timelineOpenform.timeline.dateSubmit)}}</div>
                    <el-date-picker size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                          v-model="timelineOpenform.timeline.dateSubmit"
                          type="date"   value-format="yyyy-MM-dd"
                          placeholder="Choose Date">
                        </el-date-picker>
                    <!-- <div style="text-align: left;">{{timelineOpenform.timeline.dateSubmit}}</div>
                    <input
                    v-model="timelineOpenform.timeline.dateSubmit" type="date"
                      width="100%" class="item-input"/> --></td>
                    <!-- <input type="date" v-model="timelineOpenform.timeline.date_submit" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="20%" class="header">Vendor:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.vendor}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.vendor" type="text"
                       class="item-input2"/></td>
                  <!--  <input type="text" v-model="timelineOpenform.timeline.vendor" production_countrywidth="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="20%" class="header">Production Country:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.productionCountry}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.productionCountry" type="text"
                      class="item-input2"/></td>
                    <!--  <input type="text" v-model="timelineOpenform.timeline.production_country" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                  <td width="20%" class="header">Vendor Reference / Drawing #:</td>
                  <td colspan="7">
                    <div style="text-align: left;" v-if="this.operation==='view'">{{timelineOpenform.timeline.drawingNbr}}</div>
                    <input v-if="this.operation==='edit' || this.operation==='add'" v-model="timelineOpenform.timeline.drawingNbr" type="text"
                      class="item-input2"/></td>
                    <!-- <input type="text" v-model="timelineOpenform.timeline.drawing_nbr" width="100%" class="item-input"/></td> -->
              </tr>
              <tr>
                <td width="20%" class="header">Required ETD:</td>
                <td colspan="7">
                  <div style="text-align: left;" v-if="this.operation==='view'">{{dateFormat1(timelineOpenform.timeline.requiredEtd)}}</div>
                  <el-date-picker size="mini" style="display: flex;" v-if="this.operation==='edit' || this.operation==='add'"
                        v-model="timelineOpenform.timeline.requiredEtd"
                        type="date"   value-format="yyyy-MM-dd"
                        placeholder="Choose Date">
                      </el-date-picker>
                 </td>
              </tr>
              <tr></tr>
              <tr>
                  <td width="20%" class="header1" colspan="1"></td>
                  <td width="10%" class="header1" colspan="1">Status</td>
                  <td width="10%" class="header1" colspan="1">Resp.</td>
                  <td width="10%" class="header1" colspan="1">Lead time</td>
                  <td width="10%" class="header1" colspan="1">SUPPLIER FIRST ESTIMATE</td>
                  <td width="10%" class="header1" colspan="1">REVISED ESTIMATE</td>
                  <td width="10%" class="header1" colspan="1">COMPLETED</td>
                  <td width="20%" class="header1" colspan="1">COMMENTS {{this.timelineOpenform.busiTimelines.size}}</td>
              </tr>
              <tr>
                  <td width="100%" colspan="8" rowspan="1" class="section-header">BUSINESS REQUIREMENTS</td>
              </tr>
              <template v-if="this.operation === 'edit' || this.operation === 'add'">
              <tr v-for="(tl,index) in this.timelineOpenform.busiTimelines" :key="tl.id">
                <td width="30%" class="item-header">{{ tl.item_name }}</td>
                <td width="10%"><!-- <input type="text" v-model="tl.status1" class="item-input"/> -->
                            <el-select v-model="tl.status1" collapse-tags
                      size="mini" style="display: flex;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                </td>
                <td width="10%"><input type="text" v-model="tl.resp" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.lead_time" class="item-input" oninput = "value=value.replace(/[^\d]/g,'')"/></td>
                <td width="10%"><input type="text" v-model="tl.first_estimate" data-group="1" @focus="focus" v-bind:index="index" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.revised_estimate" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.completed" class="item-input"/></td>
                <td width="20%"><input type="text" v-model="tl.comments" class="item-input"/></td>
              </tr>
              </template>
              <template v-else>
                <tr v-for="tl in this.timelineOpenform.busiTimelines" :key="tl.id">
                  <td width="30%" class="item-header">{{ tl.item_name }}</td>
                  <td width="10%">{{tl.status1}}</td>
                  <td width="10%">{{tl.resp}}</td>
                  <td width="10%">{{tl.lead_time}}</td>
                  <td width="10%">{{tl.first_estimate}}</td>
                  <td width="10%">{{tl.revised_estimate}}</td>
                  <td width="10%">{{tl.completed}}</td>
                  <td width="20%">{{tl.comments}}</td>
                </tr>
              </template>
              <tr>
                  <td width="100%" colspan="8" rowspan="1" class="section-header">STRUCTURE DEVELOPMENT</td>
              </tr>
              <template v-if="this.operation === 'edit' || this.operation === 'add'">
              <tr v-for="(tl,index) in this.timelineOpenform.structTimelines" :key="tl.id">
                <td width="30%" class="item-header">{{tl.item_name}}</td>
                <td width="10%"><!-- <input type="text" v-model="tl.status1" class="item-input"/> -->
                            <el-select v-model="tl.status1" collapse-tags
                      size="mini" style="display: flex;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                </td>
                <td width="10%"><input type="text" v-model="tl.resp" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.lead_time" class="item-input" oninput = "value=value.replace(/[^\d]/g,'')"></td>
                <td width="10%"><input type="text" v-model="tl.first_estimate" data-group="2" @focus="focus" v-bind:index="index" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.revised_estimate" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.completed" class="item-input"/></td>
                <td width="20%"><input type="text" v-model="tl.comments" class="item-input"/></td>
               </tr>
               </template>
               <template v-else>
                 <tr v-for="tl in this.timelineOpenform.structTimelines" :key="tl.id">
                   <td width="30%" class="item-header">{{ tl.item_name }}</td>
                   <td width="10%">{{tl.status1}}</td>
                   <td width="10%">{{tl.resp}}</td>
                   <td width="10%">{{tl.lead_time}}</td>
                   <td width="10%">{{tl.first_estimate}}</td>
                   <td width="10%">{{tl.revised_estimate}}</td>
                   <td width="10%">{{tl.completed}}</td>
                   <td width="20%">{{tl.comments}}</td>
                 </tr>
               </template>

               <tr>
                   <td width="100%" colspan="8" rowspan="1" class="section-header">DECORATION DEVELOPMENT</td>
               </tr>
               <template v-if="this.operation === 'edit' || this.operation === 'add'">
               <tr v-for="(tl,index) in this.timelineOpenform.decoTimelines" :key="tl.id">
                 <td width="30%" class="item-header">{{tl.item_name}}</td>
                 <td width="10%"><!-- <input type="text" v-model="tl.status1" class="item-input"/> -->
                             <el-select v-model="tl.status1" collapse-tags
                       size="mini" style="display: flex;"
                       placeholder="please choose">
                     <el-option
                     v-for="item in statusArr"
                     :key="item"
                     :label="item"
                     :value="item">
                   </el-option>
                 </el-select>
                 </td>
                 <td width="10%"><input type="text" v-model="tl.resp" class="item-input"/></td>
                 <td width="10%"><input type="text" v-model="tl.lead_time" class="item-input" oninput = "value=value.replace(/[^\d]/g,'')"></td>
                 <td width="10%"><input type="text" v-model="tl.first_estimate" data-group="3" @focus="focus" v-bind:index="index" class="item-input"/></td>
                 <td width="10%"><input type="text" v-model="tl.revised_estimate" class="item-input"/></td>
                 <td width="10%"><input type="text" v-model="tl.completed" class="item-input"/></td>
                 <td width="20%"><input type="text" v-model="tl.comments" class="item-input"/></td>
                </tr>
                </template>
                <template v-else>
                  <tr v-for="tl in this.timelineOpenform.decoTimelines" :key="tl.id">
                    <td width="30%" class="item-header">{{ tl.item_name }}</td>
                    <td width="10%">{{tl.status1}}</td>
                    <td width="10%">{{tl.resp}}</td>
                    <td width="10%">{{tl.lead_time}}</td>
                    <td width="10%">{{tl.first_estimate}}</td>
                    <td width="10%">{{tl.revised_estimate}}</td>
                    <td width="10%">{{tl.completed}}</td>
                    <td width="20%">{{tl.comments}}</td>
                  </tr>
                </template>

               <!-- <select required="required" v-on:click="javascript:if(tl.supply_first==='Date') {alert('aaa');}"
                                          v-model="tl.supply_first" class="item-input">@click="MsgBox()" :data-index={{ index }}
                                 <option value="TBC">TBC</option>
                                 <option value="NA">NA</option>
                                 <option value="Date">Date</option>
                                 </select><script></script> --><!-- <input v-if="tl.supply_first!=='TBC' && tl.supply_first!=='NA'"  type="date"/></td> -->
              <tr>
                  <td width="100%" colspan="8" rowspan="1" class="section-header">SPECIFICATIONS</td>
              </tr>
              <template v-if="this.operation === 'edit' || this.operation === 'add'">
              <tr v-for="(tl,index) in this.timelineOpenform.specTimelines" :key="tl.id">
                <td width="30%" class="item-header">{{ tl.item_name }}</td>
                <td width="10%"><!-- <input type="text" v-model="tl.status1" class="item-input"/> -->
                            <el-select v-model="tl.status1" collapse-tags
                      size="mini" style="display: flex;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                </td>
                <td width="10%"><input type="text" v-model="tl.resp" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.lead_time" class="item-input" oninput = "value=value.replace(/[^\d]/g,'')"/></td>
                <td width="10%"><input type="text" v-model="tl.first_estimate" data-group="4" @focus="focus" v-bind:index="index" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.revised_estimate" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.completed" class="item-input"/></td>
                <td width="20%"><input type="text" v-model="tl.comments" class="item-input"/></td>
               </tr>
               </template>
               <template v-else>
                 <tr v-for="tl in this.timelineOpenform.specTimelines" :key="tl.id">
                   <td width="30%" class="item-header">{{ tl.item_name }}</td>
                   <td width="10%">{{tl.status1}}</td>
                   <td width="10%">{{tl.resp}}</td>
                   <td width="10%">{{tl.lead_time}}</td>
                   <td width="10%">{{tl.first_estimate}}</td>
                   <td width="10%">{{tl.revised_estimate}}</td>
                   <td width="10%">{{tl.completed}}</td>
                   <td width="20%">{{tl.comments}}</td>
                 </tr>
               </template>
              <tr>
                  <td width="100%" colspan="8" rowspan="1" class="section-header">PRODUCTION / SHIPPING</td>
              </tr>
              <template v-if="this.operation === 'edit' || this.operation === 'add'">
              <tr v-for="(tl,index) in this.timelineOpenform.prodTimelines" :key="tl.id">
                <td width="30%" class="item-header">{{tl.item_name}}</td>
                <td width="10%"><!-- <input type="text" v-model="tl.status1" class="item-input"/>@focus="caculation" -->
                            <el-select v-model="tl.status1" collapse-tags
                      size="mini" style="display: flex;"
                      placeholder="please choose">
                    <el-option
                    v-for="item in statusArr"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
                </td>
                <td width="10%"><input type="text" v-model="tl.resp" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.lead_time" class="item-input" data-group="prod5" v-bind:index="index" oninput = "value=value.replace(/[^\d]/g,'')"/></td>
                <td width="10%"><input type="text" v-model="tl.first_estimate" data-group="5" @focus="focus" v-bind:index="index" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.revised_estimate" class="item-input"/></td>
                <td width="10%"><input type="text" v-model="tl.completed" class="item-input"/></td>
                <td width="20%"><input type="text" v-model="tl.comments" class="item-input"/></td>
               </tr>
               </template>
               <template v-else>
                 <tr v-for="tl in this.timelineOpenform.prodTimelines" :key="tl.id">
                   <td width="30%" class="item-header">{{ tl.item_name }}</td>
                   <td width="10%">{{tl.status1}}</td>
                   <td width="10%">{{tl.resp}}</td>
                   <td width="10%">{{tl.lead_time}}</td>
                   <td width="10%">{{tl.first_estimate}}</td>
                   <td width="10%">{{tl.revised_estimate}}</td>
                   <td width="10%">{{tl.completed}}</td>
                   <td width="20%">{{tl.comments}}</td>
                 </tr>
               </template>
          </tbody>
      </table>
      </div>
      <p>
          <br>
      </p>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" @click="dialogFormVisible = false">Cancel</el-button>
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="timelineSave">Save</el-button>
      <el-button v-if="this.operation==='edit' || this.operation === 'add'" type="primary" @click="timelinePublish">Publish</el-button>
      <el-button v-if="this.operation==='view'" type="primary" @click="dialogFormVisible = false">Close</el-button>
      <el-button v-if="this.operation==='view'" type="primary" v-print="'#printTest'">Print</el-button>
      <el-button v-if="this.userName.toUpperCase()==='J3P' && this.operation==='view'" type="primary"  @click="timelineArchieve">Archive</el-button>
    </div>
  </el-dialog>
  </div>
  <!--卡片视图区域 :inline="true"-->

  <el-card>
    <el-form :model="formInline" class="demo-form-inline">
      <el-row>
        <el-col :span = "6">
      <el-form-item label="Brand:" label-width="115px">
        <el-input v-model="formInline.brand" placeholder="Brand" clearable></el-input>
      </el-form-item>
      </el-col>

      <el-col :span = "7">
        <el-form-item label="Project Id:" label-width="155px">
          <el-input v-model="formInline.projectId" placeholder="Project Id" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "11">
        <el-form-item label="Date Submitted:" label-width="200px" style="margin-left: 20px;">
          <!-- <el-input v-model="formInline.loadDate" placeholder="Loading Date" clearable></el-input> -->
            <!-- <el-input v-model="formInline.loadDate" placeholder="Loading Date" clearable></el-input> -->
          <el-date-picker
                v-model="formInline.date_submit"  value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="-"
                start-placeholder="Start Date"
                end-placeholder="End Date">
              </el-date-picker>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "6">
        <el-form-item label="Comp Descr:" label-width="115px">
          <el-input v-model="formInline.componentDescr" placeholder="Component Description" clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span = "7">
        <el-form-item label="Project Desc.:" label-width="155px">
          <el-input v-model="formInline.projectDescr" placeholder="Project Desc." clearable></el-input>
        </el-form-item>
      </el-col>

      <el-col :span = "11">
        <el-form-item   label="Archived:" label-width="200px" style="margin-left: 20px;">
          <el-switch
            style="display: block"
            v-model="formInline.archieved"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="Yes"
            inactive-text="No">
          </el-switch>
        </el-form-item>
      </el-col>

        <el-col :span = "11" style="margin-left: 430px;">
      <el-form-item>
        <el-button type="primary" @click="onSubmit">Search</el-button>
        <el-button  v-if="this.userName.toUpperCase()==='J3P'" type="primary" @click="chooseProjectId">Add</el-button>
        <el-button v-if="this.userName.toUpperCase()==='J3P'" type="primary" @click="importExcel">Import</el-button>
      </el-form-item>
      </el-col>
      </el-row>

    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="timelineList" ref="timelist" border stripe style="width: 100%">
        <el-table-column type="index"  fixed label="#"></el-table-column>
        <el-table-column
          prop="brand"
          label="Brand"         sortable
          width="78">
        </el-table-column>
        <el-table-column
          prop="projectId"    :show-overflow-tooltip="true"
          label="Project ID"         sortable
          width="115">
        </el-table-column>
        <el-table-column
          prop="item"    :show-overflow-tooltip="true"
          label="Item"         sortable
          width="110">
        </el-table-column>
        <el-table-column
          prop="projectDescr"
          label="Project Descr"    :show-overflow-tooltip="true"
          width="165">
        </el-table-column>
            <!-- <el-table-column
              prop="componentId"
              label="Component ID"         sortable
              width="130">
            </el-table-column>
            <el-table-column
              prop="componentDescr"
              label="Component Description"
              width="190">
            </el-table-column> -->
            <el-table-column
              prop="revision"
              label="Revision #" :show-overflow-tooltip="true"
              width="87">
            </el-table-column>

            <el-table-column
              prop="dateSubmit"   :formatter="dateFormat"
              label="Date Submitted" :show-overflow-tooltip="true"          sortable
              width="138">
            </el-table-column>

            <el-table-column
              prop="vendor"
              label="Vendor"        sortable
              width="85">
            </el-table-column>

            <!-- <el-table-column
              prop="productionCountry"        sortable
              label="Production Country" :show-overflow-tooltip="true"
              width="170">
            </el-table-column> -->

            <el-table-column
              prop="t3"        sortable
              label="Shipping Start"
              width="142">
            </el-table-column>
            <el-table-column v-if="this.userName.toUpperCase()==='J3P'"
              prop="status"        sortable
              label="Status" :show-overflow-tooltip="true"
              width="85">
            </el-table-column>
            <!-- <el-table-column
              prop="t1"        sortable
              label="1st Sampling Submission"
              width="200">
            </el-table-column>
            <el-table-column
              prop="t2"        sortable
              label="Comments - 2nd Sampling"
              width="200">
            </el-table-column> -->
            <el-table-column  v-if="this.userName.toUpperCase()==='J3P'"
              label="Operation"
              width="350">
              <template slot-scope="props">
                <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
                <el-button type="info" plain size="mini" @click="edit(props.row.id)">Edit</el-button>
                <el-button type="info" plain size="mini" @click="del(props.row.id)">Delete</el-button>
                <el-button type="info" v-if="!archievedSearch" plain size="mini" @click="archieve(props.row.id)">Archive</el-button>
                </template>
            </el-table-column>
            <el-table-column  v-else
              label="Operation"
              width="90">
              <template slot-scope="props">
                <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button>
                </template>
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
// import qs from 'qs'// axios参数包
export default {
  data () {
    return {
      ruleForm: {
        selectedProjectId: ''
      },
      firstoptions: [{
        value: 'date',
        label: 'Date'
      }, {
        value: 'N/A',
        label: 'N/A'
      }, {
        value: 'TBC',
        label: 'TBC'
      }],
      selectedItem: '',
      loading: false,
      selectedProjectId: '',
      statusArr: ['3D', 'AS1', 'AW', 'C1', 'C2', 'C3', 'C4', 'COL', 'CRB', 'DIL', 'DWG', 'FIL', 'MKP', 'MLD', 'PO', 'PRD', 'QCAP', 'QSPEC', 'QUOT', 'SPL', 'STR', 'T1', 'T2', 'T3', 'TBA', 'TBF', 'TN', 'TPRD'],
      operation: '',
      customerNames: [{
        value: 'CSP',
        label: 'CSP'
      }, {
        value: 'EC',
        label: 'EC'
      }, {
        value: 'HBG',
        label: 'HBG'
      }, {
        value: 'IP',
        label: 'IP'
      }, {
        value: 'NPS',
        label: 'NPS'
      }, {
        value: 'OMC',
        label: 'OMC'
      }, {
        value: 'OWILD',
        label: 'OWILD'
      }, {
        value: 'TSM',
        label: 'TSM'
      }],
      // selectedItem: {g1:'',g2:'',g3:'',g4:''},
      // tlsupplyDate: {g1:'',g2:'',g3:'',g4:''},
      // sel:{g1:'',g2:'',g3:'',g4:''},
      // selVal: {
      //   value: ''
      // },‘’
      fileList: [],
      current_gp: '',
      selIndex: '',
      tl: {
        supply_first: ''
      },
      tlsupplyDate: '',
      dialogVisible: false,
      dialogVisibleImport: false,
      projectidDialogVisible: false,
      dateChooseDisabled: false,
      formInline: {
        brand: '',
        projectId: '',
        projectDescr: '',
        componentDescr: '',
        date_submit: '',
        requiredEtd: '',
        archieved: false,
        token: '',
        page: 1,
        rows: 100
      },
      userName: '',
      timelineOpenform: {
        timeline: '',
        busiTimelines: [],
        structTimelines: [],
        decoTimelines: [],
        specTimelines: [],
        prodTimelines: []
      },
      labelPosition: 'left',
      timelineList: [],
      projectIdList: [],
      categoryList: [],
      projectIdListbak: [],
      total: 0,
      updateTime: '',
      dialogFormVisible: false,
      // form: {
      //   name: '',
      //   region: ''
      // },
      formLabelWidth: '250px',
      editFormRules: {
        selectedProjectId: [
          { required: true, message: 'Please select the Project Id.', trigger: 'blur' }
        ]
      },
      archievedSearch: false
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    if (this.$route.params.selected) {
      this.formInline.projectId = this.$route.params.selected
      // window.sessionStorage.setItem('activePath', 'CRTask')
      // console.log('projectId === ' + this.$route.params.selected)
    }
    this.getTaskCategories()
    this.getTimelines()
  },
  methods: {
    remoteMethod (query) {
      // this.dimensionList = this.brandListbak
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.projectIdList = this.projectIdListbak.filter(item => {
            return item.project_id.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.descr.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.projectIdList = this.projectIdListbak
        // this.options = []
      }
    },
    // change (value) {
    // }
    // changeDate (value) {
    //   console.log('this.selectedItem111===' + this.selectedItem)
    //   if (this.selectedItem === 'date') {
    //     this.timelineOpenform.specTimelines[this.selIndex].supply_first = this.tlsupplyDate
    //     console.log('this.tlsupplyDate===' + this.tlsupplyDate)
    //   } else {
    //     this.timelineOpenform.specTimelines[this.selIndex].supply_first = this.selectedItem
    //     console.log('this.selectedItem===' + this.selectedItem)
    //   }
    // },
    async getTaskCategories () {
      const { data: res3 } = await this.$http.get('/customer/getTaskCategoryList')
      this.categoryList = await res3.taskCategoryList
    },
    caculation (event) {
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      // var lastIndex = event.target.getAttribute('index') - 1

      this.current_gp = gp
      this.selIndex = event.target.getAttribute('index')
      this.dialogVisible = true
    },
    focus (event) {
      var gp = event.target.getAttribute('data-group')
      // this.sel['g'+gp] = event.target;
      // this.selectedstyle['g'+gp] = event.target.value
      this.current_gp = gp
      this.selIndex = event.target.getAttribute('index')
      this.dialogVisible = true
    },
    chooseDate () {
      // console.log('this.selectedItem222222222==' + this.selectedItem)
      if (this.selectedItem !== 'date') {
        return true
      } else {
        return false
      }
      // return this.selectedItem !== 'date' ? true : false
      // return false。
    },
    chooseFirstDate () {
      this.dialogVisible = false
      if (this.current_gp === '1') {
        if (this.selectedItem === 'date') {
          this.timelineOpenform.busiTimelines[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.timelineOpenform.busiTimelines[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '2') {
        if (this.selectedItem === 'date') {
          this.timelineOpenform.structTimelines[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.timelineOpenform.structTimelines[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '3') {
        if (this.selectedItem === 'date') {
          this.timelineOpenform.decoTimelines[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.timelineOpenform.decoTimelines[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '4') {
        if (this.selectedItem === 'date') {
          this.timelineOpenform.specTimelines[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.timelineOpenform.specTimelines[this.selIndex].first_estimate = this.selectedItem
        }
      }
      if (this.current_gp === '5') {
        if (this.selectedItem === 'date') {
          this.timelineOpenform.prodTimelines[this.selIndex].first_estimate = this.tlsupplyDate
        } else {
          this.timelineOpenform.prodTimelines[this.selIndex].first_estimate = this.selectedItem
        }
      }
    },
    chooseFile () {
      this.dialogVisibleImport = true
    },
    // function printit(){
    // if(confirm('确认打印吗？')){
    // document.getElementById('butn').style.display="none";//隐藏
    // window.print();//打印
    // document.getElementById('butn').style.display="inline";//显示
    // }
    // }
    async chooseProjectId () {
      this.projectidDialogVisible = true
      const { data: res } = await this.$http.get('/timeline/getProspectProjectIds')
      this.projectIdList = res.projectIds
      this.projectIdListbak = this.projectIdList
    },
    async view (value) {
      this.dialogFormVisible = true
      this.operation = 'view'
      const { data: res } = await this.$http.get('/timeline/getTimeline', { params: { value: value } })
      this.timelineOpenform.timeline = res.timeline
      this.timelineOpenform.busiTimelines = res.busiTimelines
      this.timelineOpenform.structTimelines = res.structTimelines
      this.timelineOpenform.decoTimelines = res.decoTimelines
      this.timelineOpenform.specTimelines = res.specTimelines
      this.timelineOpenform.prodTimelines = res.prodTimelines
      // this.dialogFormVisible.print()
    },
    async edit (value) {
      this.dialogFormVisible = true
      this.operation = 'edit'
      const { data: res } = await this.$http.get('/timeline/getTimeline', { params: { value: value } })
      this.timelineOpenform.timeline = res.timeline
      this.timelineOpenform.busiTimelines = res.busiTimelines
      this.timelineOpenform.structTimelines = res.structTimelines
      this.timelineOpenform.decoTimelines = res.decoTimelines
      this.timelineOpenform.specTimelines = res.specTimelines
      this.timelineOpenform.prodTimelines = res.prodTimelines
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/timeline/deleteTimeline', { params: { value: value } })
        .then(res => {
          that.getTimelines()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    del (value) {
      const that = this
      this.$confirm('This will permanently delete the timeline. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmArchieve (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/timeline/archieveTimeline', { params: { value: value } })
        .then(res => {
          that.getTimelines()
          that.$message({
            message: 'archive successfully!',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: 'archive failly!',
            type: 'error'
          })
        })
    },
    archieve (value) {
      const that = this
      this.$confirm('Do you want to archive the timeline?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmArchieve(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      if (this.formInline.archieved) {
        this.archievedSearch = true
      } else {
        this.archievedSearch = false
      }
      this.getTimelines()
    },
    async getTimelines () {
      const { data: res } = await this.$http.get('/prospect/timelineList', { params: this.formInline })
      this.timelineList = res.rows
      this.total = res.total

      if (res.rows.length > 0) {
        this.updateTime = this.timelineList[0].createTime
      }
    },
    async timelineOpen () {
      this.$refs.editFormRef.validate(async valid => {
        if (valid) {
          this.projectidDialogVisible = false
          this.dialogFormVisible = true
          this.operation = 'add'
          const { data: res } = await this.$http.get('/timeline/openTimeline', { params: this.ruleForm })
          this.timelineOpenform.timeline = res.timeline
          this.timelineOpenform.subTimelines = res.subTimelines
          this.timelineOpenform.busiTimelines = res.busiTimelines
          this.timelineOpenform.structTimelines = res.structTimelines
          this.timelineOpenform.decoTimelines = res.decoTimelines
          this.timelineOpenform.specTimelines = res.specTimelines
          this.timelineOpenform.prodTimelines = res.prodTimelines
          // this.timelineOpenform.subTimelines = res.timelines
          // console.log(res)
        } else {
          console.log('error submit!!')
          return false
        }
      })

      if (this.selectedProjectId === null) {
      }

      // console.log('ccc')
      // const res = await this.$http.get('/show/scheduleList', { params: this.formInline })
      // console.log(res)
    },
    async timelineSave () {
      this.dialogFormVisible = false

      // const { data: res } = await this.$http.post('/timeline/updateTimeline', this.timelineOpenform)

      await this.$http.post('/timeline/updateTimeline', this.timelineOpenform)

      this.editDialogVisible = false
      this.$message.success('Update successfully!')

      this.getTimelines()
      // console.log(res)
    },
    async timelinePublish () {
      this.dialogFormVisible = false

      // const { data: res } = await this.$http.post('/timeline/updateTimelineByPublish', this.timelineOpenform)

      await this.$http.post('/timeline/updateTimelineByPublish', this.timelineOpenform)

      this.editDialogVisible = false
      this.$message.success('Update successfully!')

      this.getTimelines()
      // console.log(res)
    },
    async timelineArchieve () {
      this.dialogFormVisible = false

      // const { data: res } = await this.$http.post('/timeline/updateTimelineByPublish', this.timelineOpenform)

      await this.$http.post('/timeline/archieveTimeline', { params: { value: this.timelineOpenform.timeline.id } })

      this.editDialogVisible = false
      this.$message.success('Archive successfully!')

      this.getTimelines()
      // console.log(res)
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return year + '/' + month + '/' + day
    },
    importExcel () {
      this.dialogVisibleImport = true
      this.getTimelines()
      // await this.$http.post('/timeline/importFile', { params: { value: this.timelineOpenform.timeline.id } })
    },
    dateFormat1 (daterc) {
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getTimelines()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getTimelines()
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  // *{
  //   border: 20px;
  // }
  .dialogTitle{
    text-align: center;
    /* position: relative;
    left: 0px; */
    }

  .div-table {
    // font-size: 12px;
    // border-right: 1px solid #999;
    // border-right-width: medium;
    // border-right-style: none;
    // border-right-color: currentColor;
    // border-right: none;
    // border-right-color: ;
    // border-bottom: none;
    // border-bottom-color: ;
    // box-sizing: border-box;
    // border: 5px;
    // width: 100%;
    // margin-bottom: 4px;
    // margin-top: 4px;
  }
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }

  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }

  .header {
    // width: 39%;
    text-align: left;
    font-weight: 500;
  }
  .header1 {
    text-align: center;
    font-weight: 500;
    word-break: keep-all;
  }
  .item-header {
    text-align: left;
    font-weight: 300;
  }
  .item-input {
   width: 98%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input1 {
   width: 98%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
  .item-input2 {
   width: 99%;
   height: 100%;
   align: left;
   background-color: white;
   box-shadow: 0px 0px 0px #888888;
   // line-height: 20px;
   // padding-top: 3px;
   // padding-bottom: 3px;
   // border-radius: 4px;
   // border-top: 1px solid #999;
   // border-left: 1px solid #999;
   // border-bottom: 1px solid #999;
   // border-right: 1px solid #999;
   // box-shadow: 10 10 10px 1000px white inset !important;
  }
</style>
